import * as React from 'react';

const Titles = React.memo((props: { value: string }) => (
  <div
    aria-label="Title"
    className="line-clamp-3 justify-left overflow-hidden pt-[5px] leading-tight"
    title={props.value || undefined}
  >
    {props.value || '--'}
  </div>
));

Titles.displayName = 'Titles';

export default Titles;